import React, { useEffect, useState } from "react";
import { addDoc, collection, deleteDoc, doc, getDocs, getFirestore, query, updateDoc, where } from "firebase/firestore";
import SidebarApp from "../sidebar/SidebarApp";
import InterviewTable from "../InterviewTable";
import Interviewform from "../../user/Interviewform";
import { initFirebase, getCategoriesFromFirebase, removeCategoryFromFirebase } from "../../firebase";
import ChatWidget from "../ChatWidget";
const DEFAULT_CATEGORIES = [
  "polymorphism", "java8", "collection", "exceptions", "stringclass",
  "Spring", "Hibernate", "Apachekafka", "Reactjs", "Oauth2",
  "Threads", "Executors", "Aws", "jdk-latestfeatures", "Docker",
  "java11", "SpringBatch", "kubernates", "Springboot",
  "Security", "Angular", "Sql queries", "Microservices",
  "Logical Programmes"
];

function InterviewPage() {
  const app = initFirebase();
  const db = getFirestore(app);
  const colRef = collection(db, "finaltouch");

  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [items, setItems] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [editItem, setEditItem] = useState(null); // ✅ Currently editing item

  // ✅ Firebase నుండి categories load చేయండి
  useEffect(() => {
    const loadCategories = async () => {
      const firebaseCategories = await getCategoriesFromFirebase();
      const merged = [...new Set([...DEFAULT_CATEGORIES, ...firebaseCategories])];
      setCategories(merged);
    };
    loadCategories();
  }, []);

  // ✅ Category మారినప్పుడు data fetch చేయండి
  const fetchByCategory = async (category) => {
    if (!category) return;
    const q = query(colRef, where("category", "==", category));
    const snap = await getDocs(q);
    const arr = snap.docs.map(d => ({ ...d.data(), id: d.id }));
    setItems(arr);
    setShowTable(arr.length > 0);
  };

  useEffect(() => {
    fetchByCategory(selectedCategory);
  }, [selectedCategory]);

  // ✅ Edit button click — item ని form లో load చేయండి
  const handleEdit = (item) => {
    setEditItem(item);
    // Scroll to top so the form is visible
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update — Firestore లో save చేయండి
  const handleUpdate = async (updatedForm) => {
    if (!editItem) return;
    const docRef = doc(db, "finaltouch", editItem.id);
    await updateDoc(docRef, {
      answer: updatedForm.answer,
      category: updatedForm.category,
      blocks: updatedForm.blocks || [],            // ✅ rich blocks
      screenshots: updatedForm.screenshots || [],  // backward compat
    });
    setEditItem(null);
    fetchByCategory(selectedCategory);
  };

  // ✅ Delete — category empty అయితే Firebase నుండి కూడా remove చేయండి
  const handleDelete = async (db, itemId) => {
    const deletedItem = items.find(i => i.id === itemId);
    const deletedCategory = deletedItem?.category;

    await deleteDoc(doc(db, "finaltouch", itemId));

    const q = query(colRef, where("category", "==", deletedCategory));
    const snap = await getDocs(q);
    const remaining = snap.docs.filter(d => d.id !== itemId);

    if (remaining.length === 0 && !DEFAULT_CATEGORIES.includes(deletedCategory)) {
      await removeCategoryFromFirebase(deletedCategory);
      setCategories(prev => prev.filter(cat => cat !== deletedCategory));
      setSelectedCategory("");
      setItems([]);
      setShowTable(false);
    } else {
      fetchByCategory(selectedCategory);
    }
  };

  return (
    <div className="responsive-container">

      {/* ✅ Mobile sidebar toggle button */}
      <button
        className="sidebar-toggle"
        onClick={() => setSidebarOpen(prev => !prev)}
      >
        ☰
      </button>

      {/* ✅ Sidebar */}
      <SidebarApp
        categories={categories}
        selectedCategory={selectedCategory}
        onSelectCategory={(cat) => {
          setSelectedCategory(cat);
          setSidebarOpen(false);
        }}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* ✅ Main Content */}
      <div className="responsive-main">
        <Interviewform
          categories={categories}
          editItem={editItem}           // ✅ Pass edit item to form
          onSubmit={async (form) => {
            await addDoc(colRef, form);
            setSelectedCategory(form.category);
            fetchByCategory(form.category);
          }}
          onUpdate={handleUpdate}       // ✅ Update handler
          onCancelEdit={() => setEditItem(null)} // ✅ Cancel edit
          onCategoryAdded={(newCat) => {
            setCategories(prev =>
              prev.includes(newCat) ? prev : [...prev, newCat]
            );
          }}
          onSearchResult={(matchedItems) => {
            setItems(matchedItems);
            setShowTable(true);
          }}
        />

        {showTable && (
          <InterviewTable
            items={items}
            db={db}
            editId={editItem?.id}       // ✅ Pass editId to highlight editing row
            onEdit={handleEdit}         // ✅ Real edit handler
            onDelete={handleDelete}
            onHide={() => {
              setItems([]);
              setShowTable(false);
            }}
          />
        )}
      </div>
      <ChatWidget/>
    </div>
  );
}

export default InterviewPage;
